export default {
  actions: 'Actions',
  active: 'Active',
  add: 'Add',
  added: 'Added',
  after: 'After',
  all: 'All',
  attack: 'Experiment',
  authenticate: 'Authenticate',
  authentication: 'Authentication'
}
